import { openNowSSO } from '@foody/fe-common';
import actions from '../constants/actionTypes';
import { history, persist } from '../index';
import request from '../utils/request';
import { isSuccess } from '../utils/utils';
import { EnumAppType, EnumLocalStorage } from '../constants/enum';
import { startAppLoading, stopAppLoading } from '../layout/actions';

import { trans } from '../localization';
import {
  setGeneralError,
  setGeneralSuccess,
} from '../layout/components/UniversalModal/actions';
import { SUCCESS_RESPONSE, VERIFIED_OTP } from '../constants/constants';

export function setAuthentication(user) {
  return {
    type: actions.SET_AUTHENTICATION,
    user,
  };
}

export function resetAuthentication() {
  return dispatch => {
    persist.purge();
    dispatch({
      type: actions.RESET_AUTHENTICATION,
    });
    dispatch({
      type: actions.INIT_SESSION,
    });
    localStorage.removeItem(EnumLocalStorage.CURRENT_RESTAURANT)
  };
}

export function exchangeAccessToken(
  fetchData,
  targetApp = EnumAppType.NOW_MERCHANT_APP,
) {
  return async dispatch => {
    const body = { target_app: targetApp };
    const response = await request.postAuth('/api/auth/exchange_token', body);
    if (isSuccess(response)) {
      const { reply } = response;
      const resToken = {
        accessToken: reply.access_token,
        expiryTs: reply.expiry_ts,
      };
      if (targetApp === EnumAppType.NOW_MERCHANT_APP)
        dispatch({
          type: actions.EXCHANGE_ACCESS_TOKEN,
          response: resToken,
        });
      else
        dispatch({
          type: actions.EXCHANGE_ACCESS_TOKEN_EXTEND,
          response: {
            targetApp,
            tokenData: resToken,
          },
        });
      /* TODO:
          Process when change token extend  -> error_access_token
          => change token global -> change token extend -> fetchData
        */
      return fetchData(false);
    }
    return response;
  };
}

export function exchangeRawAccessToken() {
  return dispatch =>
    request.postAuth('/api/auth/exchange_token').then(response => {
      if (isSuccess(response)) {
        const { reply } = response;
        dispatch({
          type: actions.EXCHANGE_ACCESS_TOKEN,
          response: {
            accessToken: reply.access_token,
            expiryTs: reply.expiry_ts,
          },
        });
      }
    });
}

export function forgetPassword(email, successCallback, failureCallback) {
  return dispatch => {
    dispatch(startAppLoading());
    return request
      .postAuth('/api/auth/forget_password', { email })
      .then(response => {
        dispatch(stopAppLoading());
        if (response.result === 'success') {
          successCallback();
        } else {
          failureCallback(trans(response.result));
        }
      });
  };
}

export const loginWithoutUsernameOption = () => dispatch => {
  history.push(`/account/login?verifiedOtp=${VERIFIED_OTP}`);
  dispatch(resetAuthentication());
};

export function submitOTP({ auth_code }) {
  return async dispatch => {
    dispatch(startAppLoading());
    try {
      const response = await request.postMerchant('/api/user/verify_phone', {
        auth_code,
      });

      switch (response.result) {
        case SUCCESS_RESPONSE:
          dispatch(
            setGeneralSuccess(trans('rebranding.otp_popup_message_success_verify'), {
              title: trans('otp_popup_title_success_verify'),
              extraActions: [
                {
                  name: trans('got_it_btn'),
                  onClick: () => dispatch(loginWithoutUsernameOption()),
                },
              ],
              withCloseButton: false,
            }),
          );
          break;
        case 'error_switch_account':
          dispatch(
            setGeneralSuccess(trans('error_switch_account'), {
              extraActions: [
                {
                  name: trans('btn_re_login'),
                  onClick: () => dispatch(loginWithoutUsernameOption()),
                },
              ],
              withCloseButton: false,
            }),
          );
          break;
        case 'error_verify_phone_failed':
          dispatch(
            setGeneralSuccess(trans('error_verify_phone_failed'), {
              extraActions: [
                {
                  name: trans('phone_logout'),
                  type: 'cancel',
                  onClick: () => dispatch(resetAuthentication()),
                },
                {
                  name: trans('go_verify_btn'),
                  onClick: () =>
                    openNowSSO({
                      successCallback: data => dispatch(submitOTP(data)),
                    }),
                  closeAfterAction: false,
                },
              ],
            }),
          );
          break;
        case 'error_phone_number_used':
          dispatch(
            setGeneralSuccess(trans('otp_popup_message_number_used'), {
              extraActions: [
                {
                  name: trans('login'),
                  onClick: () => dispatch(resetAuthentication()),
                },
              ],
            }),
          );
          break;
        case 'error_account_verified':
          dispatch(
            setGeneralSuccess(trans('error_account_verified'), {
              extraActions: [
                {
                  name: trans('login'),
                  onClick: () => dispatch(resetAuthentication()),
                },
              ],
            }),
          );
          break;
        default:
          break;
      }
    } finally {
      dispatch(stopAppLoading());
    }
  };
}

export function verifyOTP() {
  return dispatch => {
    dispatch(
      setGeneralError(trans('otp_popup_mess_success_verify'), {
        title: trans('verify_account_title'),
        extraActions: [
          {
            name: trans('phone_logout'),
            type: 'cancel',
            onClick: () => {
              dispatch(resetAuthentication());
            },
          },
          {
            name: trans('go_verify_btn'),
            onClick: () =>
              openNowSSO({
                successCallback: data => dispatch(submitOTP(data)),
              }),
            closeAfterAction: false,
          },
        ],
        withCloseButton: false,
      }),
    );
  };
}



// WEBPACK FOOTER //
// ./foody/src/authentication/actions.js